import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ErrorMessageDirective } from '../../directives/error-message.directive';
import { MiscModule } from '../../misc.module';
import { ChangePasswordPageRoutingModule } from './change-password-routing.module';
import { ChangePasswordPageComponent } from './change-password.page';

@NgModule({
  declarations: [ChangePasswordPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ChangePasswordPageRoutingModule,
    ReactiveFormsModule,
    MiscModule,
    ErrorMessageDirective
  ]
})
export class ChangePasswordPageModule {}
